export default __webpack_public_path__ + "9cc92ff7540a3be0e4f076f3deb198e5.jpeg";